import { render, staticRenderFns } from "./LoginPwd.vue?vue&type=template&id=7a6f09d2&"
import script from "./LoginPwd.vue?vue&type=script&lang=js&"
export * from "./LoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./LoginPwd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports